import cn from 'classnames';

import OPE from 'js/on-page-editing';

import YoutubeVideo from 'components/youtube-video/YoutubeVideo';
import EmbedBlock from 'components/embed-block/EmbedBlock';
import Link from 'components/link/Link';
import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';

import { IMediaBlock } from 'source/NFR.types';

const MediaBlock: React.FC<IMediaBlock> = ({
  title,
  onPageEditing,
  youTubeVideo,
  embed,
  image,
  link,
  icon,
  caption
}) => {
  const hasTitle = Boolean(title || onPageEditing?.title);

  return (
    <div className={cn('media-block', { 'media-block--has-title': hasTitle })}>
      {title && <h2 {...OPE(onPageEditing?.title)}>{title}</h2>}
      <div className="media-block__content">
        {youTubeVideo && (
          <div>
            {icon && <Image className="media-block__youtube-icon" {...icon} responsive={false} />}
            <YoutubeVideo {...youTubeVideo} />
          </div>
        )}
        {embed && (
          <div className="media-block__embed">
            <EmbedBlock {...embed} />
          </div>
        )}
        {image && (
          <div className="media-block__image">
            <Image {...imageSizes.mediaBlock} {...image} />
          </div>
        )}
        {caption && (
          <div className="media-with-caption__caption" {...OPE(onPageEditing?.caption)}>
            {caption}
          </div>
        )}
        {link && <Link className="media-block__link" url={link.url} text={link.text} theme="actionLink"></Link>}
      </div>
    </div>
  );
};

MediaBlock.displayName = 'MediaBlock';

export default MediaBlock;
